module.exports = __webpack_public_path__ + "img/314-f05bdd.png";